import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// ✅ NEW: Robust currency formatter
export const formatCurrency = (amount, currencyCode = 'USD') => {
  if (amount === null || amount === undefined) return '';
  
  // List of supported currencies (add more if needed)
  const validCurrencies = ['USD', 'EUR', 'GBP', 'SAR', 'AED', 'EGP', 'RWF', 'IQD', 'JOD', 'KWD', 'BHD', 'OMR', 'QAR'];
  const safeCurrency = validCurrencies.includes(currencyCode?.toUpperCase()) 
    ? currencyCode.toUpperCase() 
    : 'USD';

  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: safeCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (e) {
    // Fallback if the environment doesn't support the currency
    return `${safeCurrency} ${Number(amount).toLocaleString()}`;
  }
};